import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lm-order-preview',
  templateUrl: './order-preview.component.html',
  styleUrls: ['./order-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderPreviewComponent implements OnInit {
  showContent = false;
  @Input() id = '0';
  @Input() brand = 'Brand';
  @Output() openOrderDetails = new EventEmitter<string>();
  ngOnInit(): void {}
  showOrderPreview() {
    this.showContent = !this.showContent;
  }
}
